import { render, staticRenderFns } from "./showViewDetails.vue?vue&type=template&id=2a3b0c3a&"
import script from "./showViewDetails.vue?vue&type=script&lang=js&"
export * from "./showViewDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports